import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLikeFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M39.878 10.17c-4.193-4.194-11.014-4.192-15.206 0l-.672.672-.672-.672c-2.031-2.031-4.73-3.149-7.603-3.149s-5.572 1.118-7.603 3.149-3.149 4.73-3.149 7.603 1.119 5.571 3.149 7.603L24 41.252l15.877-15.877c2.031-2.031 3.149-4.73 3.149-7.603s-1.118-5.572-3.148-7.602" }) }) })
});
export default SvgLikeFill;
